export function DateTimeConverter(date) {
  const originalDateTime = new Date(date)
  const formattedDateTime = originalDateTime.toLocaleString('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
  return formattedDateTime
}

export function DateYYYYMMDD(date) {
  const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    '0',
  )}-${String(date.getDate()).padStart(2, '0')}`

  return formattedDate
}

export function isExpired(expiryDate) {
  const currentDate = new Date()
  const givenDate = new Date(expiryDate)

  return givenDate < currentDate
}

export function isValidJSON(str) {
  try {
    JSON.parse(str)
    return true
  } catch (e) {
    return false
  }
}

export function openLink(link) {
  window.open(link, '_blank', 'noopener,noreferrer')
}

export function generateColors(count) {
  const colors = []
  for (let i = 0; i < count; i++) {
    const color = `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)` // Generate random HSL color
    colors.push(color)
  }
  return colors
}

export function convertToWords(num) {
  const a = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen',
  ]

  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']

  if (typeof num !== 'number' || isNaN(num)) return 'Invalid number'

  if (num === 0) return 'Zero Only.'

  if (num < 0) return 'Negative numbers not supported.'

  const convert = (n) => {
    if (n < 20) return a[n]
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '')
    if (n < 1000)
      return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + convert(n % 100) : '')
    if (n < 100000)
      return convert(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + convert(n % 1000) : '')
    if (n < 10000000)
      return (
        convert(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + convert(n % 100000) : '')
      )
    if (n < 1000000000)
      return (
        convert(Math.floor(n / 10000000)) +
        ' Crore' +
        (n % 10000000 ? ' ' + convert(n % 10000000) : '')
      )
    return 'Number too large'
  }

  return convert(num) + ' Only.'
}

export function fileName(all) {
  const date = new Date()
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const month = monthNames[date.getMonth()]
  const year = date.getFullYear()

  let name = all + 'Report' + ' ' + month + ', ' + year

  return name
}
